import { useEffect, useState } from 'react';

/**
 * True once `key` has been pressed `count` times within any `windowMs` span
 * (sliding window; held-key auto-repeat is ignored). Stays true until the
 * caller unmounts. Used to reveal hidden links without a visible control.
 */
export function useKeyBurst(key: string, count: number, windowMs: number): boolean {
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    let presses: number[] = [];
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== key || event.repeat) return;
      const now = Date.now();
      presses = [...presses.filter((at) => now - at <= windowMs), now];
      if (presses.length >= count) setTriggered(true);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [key, count, windowMs]);

  return triggered;
}
